
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slots/[id]/for-real-money",
      function () {
        return require("private-next-pages/slots/[id]/for-real-money/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slots/[id]/for-real-money"])
      });
    }
  